require('../../modules/es.object.entries');
var path = require('../../internals/path');

module.exports = path.Object.entries;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/object/entries.js
// module id = 1221
// module chunks = 1